import { createContext, useContext, useEffect, useState } from "react";
import { auth as authApi } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("flyvac_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("flyvac_token");
    if (!token) {
      setReady(true);
      return;
    }
    authApi
      .me()
      .then((u) => {
        setUser(u);
        localStorage.setItem("flyvac_user", JSON.stringify(u));
      })
      .catch(() => {
        localStorage.removeItem("flyvac_token");
        localStorage.removeItem("flyvac_user");
        setUser(null);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (login, password) => {
    const { token, user: u } = await authApi.login(login, password);
    localStorage.setItem("flyvac_token", token);
    localStorage.setItem("flyvac_user", JSON.stringify(u));
    setUser(u);
    // Share session with Electron main process (no-op in the browser).
    if (typeof window !== "undefined" && window.electronAPI) {
      window.electronAPI.session.set({
        token,
        apiBase: process.env.REACT_APP_BACKEND_URL,
        user: u,
      });
    }
    return u;
  };

  const logout = () => {
    localStorage.removeItem("flyvac_token");
    localStorage.removeItem("flyvac_user");
    setUser(null);
    if (typeof window !== "undefined" && window.electronAPI) {
      window.electronAPI.session.clear();
    }
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, ready }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
